import { render, staticRenderFns } from "./ChatPromptAlerts.vue?vue&type=template&id=81b4fe66&scoped=true"
import script from "./ChatPromptAlerts.vue?vue&type=script&lang=js"
export * from "./ChatPromptAlerts.vue?vue&type=script&lang=js"
import style0 from "./ChatPromptAlerts.vue?vue&type=style&index=0&id=81b4fe66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b4fe66",
  null
  
)

export default component.exports